/**
 * Schemas Zod para autenticación
 * Mismo sistema de validación que el backend
 */

import { z } from 'zod';

// Schemas base reutilizables
export const emailSchema = z
  .string()
  .email('Email inválido')
  .trim()
  .toLowerCase();

export const passwordSchema = z
  .string()
  .min(6, 'La contraseña debe tener al menos 6 caracteres');

export const phoneSchema = z
  .string()
  .regex(/^\+?[\d\s-]{8,}$/, 'Teléfono inválido')
  .trim();

export const fullNameSchema = z
  .string()
  .min(2, 'El nombre debe tener al menos 2 caracteres')
  .trim();

export const photoUrlSchema = z
  .string()
  .url('URL de foto inválida');

/**
 * Schema para registro de usuario (admin)
 * Mismo que el backend: POST /auth/register
 * Nota: photoUrl se agrega después de subir la imagen a Storage
 */
export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  fullName: fullNameSchema,
  phone: phoneSchema,
  photoUrl: photoUrlSchema, // Se valida pero se agrega después de subir la imagen
});

export type RegisterFormData = z.infer<typeof registerSchema>;

/**
 * Schema para login
 */
export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
});

export type LoginFormData = z.infer<typeof loginSchema>;

